import { IconType } from "react-icons";
import {
  LuUser,
  LuCrosshair,
  LuSettings,
  LuBackpack,
  LuBookOpen,
  LuPickaxe,
  LuPaperclip,
} from "react-icons/lu";
import { MENU_SCREEN } from "../../../menu.types";
import { LuSwords } from "react-icons/lu";

export interface SidebarItem {
  id: string;
  label: string;
  description: string;
  icon: IconType;
  screen?: MENU_SCREEN;
  redirectTo?: string;
}

const leftSidebarItems: SidebarItem[] = [
  {
    id: "profil",
    label: "PROFIL",
    description: "Vizualizeaza i editeaza profilul tvog igraca.",
    icon: LuUser,
    screen: MENU_SCREEN.Profile,
  },
  {
    id: "jobs",
    label: "JOB-URI",
    description: "Lorem ipsum is simply dummy text...",
    icon: LuPickaxe,
    screen: MENU_SCREEN.Jobs,
  },
  /*{
    id: "misiuni",
    label: "MISIUNI",
    description: "Completeaj misiue za exluzivine nagrade.",
    icon: LuCrosshair,
    screen: MENU_SCREEN.Missions,
  }, */
  {
    id: "reports",
    label: "Creeaza Ticket",
    description: "test",
    icon: LuPaperclip,
    screen: MENU_SCREEN.Report,
  },
  {
    id: "battlepass",
    label: "Battlepass",
    description: "bla bla bla",
    icon: LuSwords,
    redirectTo: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
  },
  {
    id: "wiki",
    label: "WIKI",
    description: "Regulamente, ghiduri, joburi și documentație oficială.",
    icon: LuBookOpen,
    //screen: MENU_SCREEN.Wiki,
    redirectTo: "https://atlantis.mp/wiki",
  },
  {
    id: "setari",
    label: "SETARI",
    description: "Configure your account and game settings.",
    icon: LuSettings,
    screen: MENU_SCREEN.Settings,
  },

  /* {
    id: "inventory",
    label: "BACKPACK",
    description: "Pregledaj sve iteme koje posjedujes.",
    icon: LuBackpack,
    screen: MENU_SCREEN.Backpacks,
  }, */

  /** {
    id: "reguli",
    label: "REGULI",
    description: "Regulamentul oficial al serverului.",
    icon: LuBookOpen,
    screen: MENU_SCREEN.Rules,
  }, */
];

export default leftSidebarItems;
